import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Auth from "../../services/Auth.service";
import FarmsService from "../../services/farms.service";

import FarmMovementsComponents from "../../components/FarmsComponents/FarmMovementsComponents";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";

export default function FarmFeedMovements(props) {
    const { t } = useTranslation();
    const { params } = props.match;

    const [farm, setFarm] = React.useState({
        farmId: 0,
        integratorId: 0,
        integratorCode: "",
        manufacturerCode: "",
        name: "",
        officialMark: "",
        regaCode: "",
        gpsCordinates: "",
        address: "",
        city: "",
        postcode: "",
        provinceId: 0,
        countryId: "",
        remarks: "",
        isInactive: true,
        region: "",
        distributionZoneId: 0,
        farmTypeId: 0,
        efficiencyRatio: 0,
      });
    
      React.useEffect(() => {
        FarmsService.getFarm(params.farmId)
          .then((response) => response.data)
          .then((json) => {
            const { contract } = json;
            setFarm({
              farmId: contract.farmId,
              integratorId: contract.integratorId,
              integratorCode: contract.integratorCode,
              manufacturerCode: contract.manufacturerCode,
              name: contract.name,
              officialMark: contract.officialMark,
              regaCode: contract.regaCode,
              gpsCordinates: contract.gpsCordinates,
              address: contract.address,
              city: contract.city,
              postcode: contract.postcode,
              provinceId: contract.provinceId,
              countryId: contract.countryId,
              remarks: contract.remarks,
              isInactive: contract.isInactive,
              region: contract.region,
              distributionZoneId: contract.distributionZoneId,
              farmTypeId: contract.farmTypeId,
              efficiencyRatio: contract.efficiencyRatio,
            });
          });
      }, [params.farmId]);

    return (
        <div>
              {Auth.isUserLoged ? (
                <div>
                  <br />
                  <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                          <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                          <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                          <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/GeneralInformation'}>{farm.name}</Link></li>
                          <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/Movements'}>{t("Farm_Details_Movements")}</Link></li>
                        </ol>
                      </nav>
                      <NavegacionFarms farmId={farm.farmId} />
                    </div>
                  </div>
        
                  <div>
                    <FarmMovementsComponents farm={farm} />
                  </div>
        
                  <br />
                </div>
              ) : (
                ""
              )}
        </div>
    );
}
